import { render, staticRenderFns } from "./ControleIntimacao.vue?vue&type=template&id=06ae8f5b&scoped=true"
import script from "./ControleIntimacao.vue?vue&type=script&lang=js"
export * from "./ControleIntimacao.vue?vue&type=script&lang=js"
import style0 from "./ControleIntimacao.vue?vue&type=style&index=0&id=06ae8f5b&prod&scoped=true&lang=css"
import style1 from "./ControleIntimacao.vue?vue&type=style&index=1&id=06ae8f5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae8f5b",
  null
  
)

export default component.exports